import * as React from "react";
import { makeStyles } from "@material-ui/core";
import classnames from "classnames";

// styles
import { colors, helpers } from "@styles/color.styles";
import { fontFamilySans } from "@styles/type.styles";

export interface ProBadgeProps {
  className?: string;
}

const useStyles = makeStyles({
  pro: {
    fontFamily: fontFamilySans,
    color: colors.blueDusk.lighter,
    cursor: "default",
    padding: "4px 4px 3px",
    fontSize: 11,
    background: helpers.opacity(colors.blueDusk.lighter, 0.3),
    textAlign: "center",
    fontWeight: "bold",
    borderRadius: 3,
    textTransform: "uppercase",
    display: "inline",
  },
  bold: {
    fontWeight: "bold",
  },
});

export const ProBadge = ({ className }: ProBadgeProps) => {
  const classes = useStyles();

  return <span className={classnames(classes.pro, className)}>Pro</span>;
};
